export default __webpack_public_path__ + "static/media/TDS-1.77a0e7d9.jfif";